import styled from 'styled-components';

export const Image = styled.img<{
  appearance?: 'circle' | 'square';
  size: number;
}>`
  height: ${({ size }) => size}px;
  position: absolute;
  left: 0;
  top: 0;
  ${({ appearance }) => appearance === 'circle' && `border-radius: 50%;`}
`;

export const Container = styled.div<{ size: number }>`
  position: relative;
  display: flex;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`;
